import React from "react";
import { MotionModal, ModalCloseButton } from "../motion";
import { RoundedChecklistIcon, WarningIcon } from "../icons";

// "It worked" / "it failed" popup for customer pages. The look is the
// edit / cancel booking result popups (SuccessSubmitEditBookingModal,
// CancelBookingSuccessModal, booking-edit ErrorModal): a large coloured icon,
// a title in the same colour, then the details in grey.
//
// <StatusModal show onClose={close} status="success" title="Saved" />
// <StatusModal show onClose={close} status="error" title="Could not save" message="Try again later." />

export const STATUS = {
  SUCCESS: "success",
  ERROR: "error",
};

const ICON_SIZE = 48;

const STATUS_STYLES = {
  [STATUS.SUCCESS]: {
    color: "#3CAEA3", // teal, as in the edit / cancel success popups
    titleColorClass: "tw:!text-[#3CAEA3]",
    renderIcon: (color) => <RoundedChecklistIcon color={color} size={ICON_SIZE} />,
  },
  [STATUS.ERROR]: {
    color: "#ED553B", // red, as in the booking-edit error popup
    titleColorClass: "tw:!text-[#ED553B]",
    // WarningIcon is 19×16, so it takes width/height instead of size.
    renderIcon: (color) => <WarningIcon color={color} width={ICON_SIZE + 8} height={(ICON_SIZE + 8) * (16 / 19)} />,
  },
};

/**
 * @param {boolean} show
 * @param {Function} onClose - ✕, Escape and backdrop click
 * @param {"success"|"error"} [status="success"]
 * @param {React.ReactNode} [title]
 * @param {string} [titleHtml] - title with markup from translations (instead of `title`)
 * @param {React.ReactNode} [message]
 * @param {React.ReactNode} [children] - anything below the message (e.g. a resend button)
 */
const StatusModal = ({ show, onClose, status = STATUS.SUCCESS, title, titleHtml, message, children }) => {
  const statusStyle = STATUS_STYLES[status] || STATUS_STYLES[STATUS.SUCCESS];
  const titleClasses = `tw:!text-[20px] tw:leading-[30px] tw:!font-[600] tw:font-hanken-grotesk tw:!mb-0 ${statusStyle.titleColorClass}`;

  return (
    <MotionModal
      show={show}
      onClose={onClose}
      maxWidthClassName="tw:max-w-[660px]"
      panelClassName="tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8"
    >
      <ModalCloseButton onClick={onClose} />

      <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:mt-4">
        <div className="tw:mb-4">{statusStyle.renderIcon(statusStyle.color)}</div>

        {titleHtml ? (
          <p className={titleClasses} dangerouslySetInnerHTML={{ __html: titleHtml }} />
        ) : (
          <p className={titleClasses}>
            {title}
          </p>
        )}

        {message ? (
          <div className="tw:mt-2 tw:!text-[15px] tw:!font-[400] tw:!text-[#4E4E4E]">{message}</div>
        ) : null}

        {children ? <div className="tw:mt-6 tw:w-full">{children}</div> : null}
      </div>
    </MotionModal>
  );
};

export default StatusModal;
